export default function CarrierPerformanceManagement() {

  return (
      <p>نظارت بر عملکرد شرکت های حمل</p>
  );
};